import { User } from 'lib-shared-types-api';
import { connect } from 'react-redux';

import { AppDispatch } from 'bootstrap.store';
import { hasFeature } from 'components/shared/featureFlag';
import { userModalActions } from 'components/usersModal';
import { withRouter } from 'hocs/router';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import { presenceActions } from '../actions/presenceActions';
import PresenceOverlay from '../components/PresenceOverlay';

const { presenceSetOthersSimultaneousRinging } = presenceActions;

const mapStateToProps = (state: any) => {
  let canMakeInternalCall = true;
  // We already have a active phone conversation in our load description. We cannot start a new one.
  const foundSpeakLoad =
    state.presence.presence.presence_status.load_descriptions.filter(
      (o: any) =>
        (o.conversation_channel === 'pstnphone' ||
          o.conversation_channel === 'callback') &&
        o.load_type !== 'acw' &&
        o.load_type !== 'nonlive',
    ).length;

  if (foundSpeakLoad > 0 || state.telephony.isMicrophoneBlocked === true) {
    canMakeInternalCall = false;
  }

  return {
    meta: state.presence.meta,
    canMakeInternalCall: canMakeInternalCall,
    featureFlags: state.settings.organization.featureflags,
    hasChannelPhone: hasFeature(state, 'phone-channel'),
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    internalCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioMakeInternalCall,
    ),
    showUserModal: (payload: { user: Partial<User> }) =>
      dispatch(userModalActions.show(payload)),
    presenceSetOthersSimultaneousRinging: bindActionToPromise(
      dispatch,
      presenceSetOthersSimultaneousRinging,
    ),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PresenceOverlay as any),
);
